import { defineMeta } from '@/registry/types';

export const typographyMeta = defineMeta({
  name: 'Typography',
  level: 'atom',
  category: 'data-display',
  classification: 'themed-mui',
  description:
    'Text primitive with the design system type scale and system-native font stack. Themed MUI Typography with no external font loading required.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Typography',
  muiDocs: 'https://mui.com/material-ui/react-typography/',
  a2uiEquivalent: 'Text',
  importPath: '@/atoms/Typography',
  optionalProps: ['variant', 'color', 'align', 'noWrap', 'gutterBottom', 'component'],
  supportedStates: ['default'],
  designTokens: ['typography', 'colors'],
  accessibility: [
    'Use semantic variants and the `component` prop to keep heading order correct.',
    'Avoid skipping heading levels for styling reasons.',
  ],
  usageExamples: [
    '<Typography variant="h4">Security overview</Typography>',
    '<Typography variant="body1" color="text.secondary">Supporting copy</Typography>',
    '<Typography variant="caption">Last seen 10h ago</Typography>',
  ],
  rules: [
    'Always set `variant` explicitly — do not rely on the body1 default.',
    'Pick the variant for the role: h4 page title, h6 drawer/empty-state heading, subtitle1 card or accordion title, subtitle2 compact heading, body1 for default reading text (14px), body2 only for dense annotations (12px), caption metadata, overline labels.',
    'A container that may hold non-text children applies the variant via `sx={{ typography: "body1" }}` on a Box, so it does not wrap a table in a `<p>`.',
  ],
  antiPatterns: [
    'Do not use h1-h6 purely for size; pick the right semantic level.',
    'Do not style a Box or span with a font-size literal when a Typography variant exists.',
    'Do not omit `variant` and then override fontSize in sx.',
  ],
  llmSafe: true,
  whenToUse: ['All text content that is not already owned by another component slot'],
  whenNotToUse: [
    'Interactive labels handled by their own components (Button, Chip, FormField, EmptyState title/description, DialogTitle, AlertTitle)',
  ],
});

export default typographyMeta;
